import React from 'react';
import EmptyPage from '../../empty-page/emptyPage';

const OrgCampAnalytics = () => {
    return <EmptyPage />;
};

export default OrgCampAnalytics;
